import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/img/bemax.png'


const _hoisted_1 = {
  key: 0,
  class: "be-max-modal"
}
const _hoisted_2 = { class: "be-max-modal__button" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "be-max-modal__container-line"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.checkBeMax)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.mode == 'img')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "be-max-modal__container-img",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModal('first')))
              }, [
                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "be-max-modal__img" }, [
                  _createElementVNode("img", { src: _imports_0 })
                ], -1)),
                _createElementVNode("button", _hoisted_2, [
                  (_ctx.label)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.label), 1))
                    : _createCommentVNode("", true),
                  _cache[7] || (_cache[7] = _createElementVNode("p", { class: "mb-0" }, "Veja como melhorar seus resultados", -1))
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("button", {
                  class: "be-max-modal__text",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showModal('first')))
                }, _cache[9] || (_cache[9] = [
                  _createElementVNode("i", { class: "icon-nav-insight" }, null, -1),
                  _createElementVNode("span", null, "Veja como melhorar seus resultados", -1),
                  _createElementVNode("i", { class: "icon-nav-arrow_right" }, null, -1)
                ]))
              ]))
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Dialog, {
      class: "be-max-modal__first-dialog",
      visible: _ctx.modals.first,
      draggable: false,
      modal: true,
      closable: true,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (_ctx.hideModal('first')))
    }, {
      header: _withCtx(() => [
        _createElementVNode("header", null, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.beMax.title), 1),
          _createElementVNode("h2", null, _toDisplayString(_ctx.beMax.subtitle), 1)
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showModal('second')))
          }, _cache[10] || (_cache[10] = [
            _createElementVNode("i", { class: "icon-nav-arrow_right" }, null, -1),
            _createTextVNode(" Clique aqui ")
          ]))
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", null, _toDisplayString(_ctx.beMax.message), 1)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      class: "be-max-modal__second-dialog",
      visible: _ctx.modals.second,
      draggable: false,
      modal: true,
      closable: true,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => (_ctx.hideModal('second')))
    }, {
      header: _withCtx(() => _cache[11] || (_cache[11] = [
        _createElementVNode("header", null, [
          _createElementVNode("h1", null, "Essa lista ajudará você a alcançar seus objetivos!")
        ], -1)
      ])),
      default: _withCtx(() => [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.beMax.resources, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              onClick: ($event: any) => (_ctx.showModal('third', item.link))
            }, [
              _createElementVNode("h3", null, [
                _cache[12] || (_cache[12] = _createElementVNode("i", { class: "icon-nav-arrow_right" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(item.title), 1)
              ]),
              _createElementVNode("p", null, _toDisplayString(item.description), 1)
            ], 8, _hoisted_5))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      class: "be-max-modal__third-dialog",
      visible: _ctx.modals.third,
      draggable: false,
      modal: true,
      closable: true,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => (_ctx.hideModal('third')))
    }, {
      header: _withCtx(() => [
        _createElementVNode("button", {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.hideModal('third')))
        }, _cache[13] || (_cache[13] = [
          _createElementVNode("i", { class: "icon-nav-arrow_left" }, null, -1),
          _createTextVNode(" Voltar para lista de conteúdos ")
        ]))
      ]),
      default: _withCtx(() => [
        _createElementVNode("iframe", {
          width: "100%",
          height: "100%",
          src: _ctx.GoogleDriveVerify(_ctx.modalPDF)
        }, null, 8, _hoisted_6)
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}